import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getLinkedAccounts, addLinkedAccount, removeLinkedAccount, getFees } from '../../API';
import { getCurrency } from '../../Helper';
import AccountCard from '../Account/AccountCard';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import ItemizedFees from '../Fee/ItemizedFees';
import FeeTable from '../Fee/FeeTable';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import QueryString from 'query-string';

function PublicHome(props) {
    const [linkedAccounts, setLinkedAccounts] = useState([]);
    const [isLoadingLinkedAccounts, setIsLoadingLinkedAccounts] = useState(true);
    const [accountSelectModal, setAccountSelectModal] = useState(false);
    const [fees, setFees] = useState([]);
    const [isLoadingFees, setIsLoadingFees] = useState(false);

    useEffect(() => {
        fetchLinkedAccounts();
    }, []);

    useEffect(() => {
        fetchFees();
    }, [linkedAccounts]);

    const fetchLinkedAccounts = async () => {
        try {
            setIsLoadingLinkedAccounts(true);

            const queryStringParams = QueryString.parse(props.location.search);
            if (queryStringParams.linkAccountId) {
                const linkAccountId = +(queryStringParams.linkAccountId);
                if (!linkedAccounts.find(l => l.accountID == linkAccountId)) {
                    await addLinkedAccount(linkAccountId);
                }
            }

            const linkedAccountsResult = await getLinkedAccounts();
            setLinkedAccounts(linkedAccountsResult || []);
        } catch (ex) {
            setLinkedAccounts([]);
        } finally {
            setIsLoadingLinkedAccounts(false);
        }
    };

    const fetchFees = async () => {
        try {
            if (linkedAccounts.length > 0) {
                setIsLoadingFees(true);

                const accountIds = linkedAccounts.map(la => la.accountID);
                const feesResult = await getFees({ accountIDs: accountIds, paid: 0 });
                console.log(accountIds, feesResult);
                setFees(feesResult);
            } else {
                setFees([]);
            }
        } catch {
            setFees([]);
        } finally {
            setIsLoadingFees(false);
        }
    };

    const unlinkAccount = async (accountId) => {
        await removeLinkedAccount(accountId);
    };

    const goToLinkAccounts = () => {
        props.history.push('/linkAccounts');
    }

    const goToPayFees = () => {
        props.history.push('/payFees');
    }

    const accountCardOptions = {
        fields: {
            active: false,
            accountNumber: true,
            account: true,
            contact: true,
            address: true,
            email: true,
            balance: false
        },
        actions: {
            view: false,
            edit: false,
            makePayment: false,
            generateLetter: false,
            delete: false,
            select: false,
            cancel: false,
            unlink: true,
        }
    };

    const noAccountsJSX = (
        <div className="public-no-accounts">
            <div className="no-accounts-text">You don't have an account linked.</div>
            <Button className="btn-icon" color="danr-blue" onClick={goToLinkAccounts}><FontAwesomeIcon icon={faLink} /><span>Link Account</span></Button>
        </div>
    );

    const loadingJSX = (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>);

    if (isLoadingLinkedAccounts) {
        
    } else if (linkedAccounts !== null && linkedAccounts.length > 0) {
        const accountsJSX = linkedAccounts.map(o => (<AccountCard account={o} key={o.accountID} options={accountCardOptions} unlink={unlinkAccount}/>));
    }

    const feeOptions = {
        fields: {
            accountNumber: true,
            account: false,
            division: true,
            facility: true,
            identifier: true,
            description: true,
            fiscalYear: true,
            amount: false,
            balance: true,
            dueDate: true,
            paidInFull: false,
            actions: false
        },
        footer: {
            amountTotal: false,
            balanceTotal: false
        },
        actions: {
            add: false,
            view: false,
            edit: false,
            delete: false,
            viewAccount: false
        }
    };

    const totalBalance = fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0);
    const homeJSX = (
        <div>
            <div className="total-due"><span className="total-due-label">Total Due:</span><span className="total-due-value">{getCurrency(totalBalance)}</span></div>
            {fees.length > 0 ? (<FeeTable fees={fees} options={feeOptions} />) : null}
            <div className="pay-fees-button">
                <Button className="btn-icon" color="danr-green" onClick={goToPayFees}><FontAwesomeIcon icon={faCreditCard} /><span>Pay Fees</span></Button>
            </div>
        </div>
    );

    return (
        <div id="publicHome">
            {isLoadingLinkedAccounts || isLoadingFees ? loadingJSX : (linkedAccounts.length > 0 ? homeJSX : noAccountsJSX)}
        </div>
    );
}

export default PublicHome;